import { MouseEventHandler, ReactNode } from 'react';
import { VideoCallDisabledReasonsType } from 'types';
import { Fade } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { COLORS } from 'theme/MainTheme';
import { FormattedMessage } from 'react-intl';

const useStyles = makeStyles(() => ({
  message: {
    fontSize: 25,
    lineHeight: 1.75,
    padding: '10%',
    textAlign: 'center',

    '@media (max-width: 1199px)': {
      fontSize: 20,
    },
  },
  overlay: {
    alignItems: 'center',
    background: COLORS.MEDIUM_GREY,
    borderRadius: 15,
    boxShadow: '0px 3px 5px 1px rgb(0 0 0 / 25%)',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    height: '100%',
    // Prevent 1x border from underlying image
    marginLeft: -1,
    maxWidth: 601,
    position: 'absolute',
    top: 0,
    transform: 'scale(0.95)',
  },
}), { name: 'VideoCallCategoryDisabledOverlay' });

type VideoCallCategoryDisabledOverlayPureProps = {
  message: ReactNode;
  onMouseLeave: MouseEventHandler;
};

const VideoCallCategoryDisabledOverlayPure = ({
  message,
  onMouseLeave,
}: VideoCallCategoryDisabledOverlayPureProps): JSX.Element => {
  const classes = useStyles();
  return (
    <Fade in timeout={500}>
      <div className={classes.overlay} onMouseLeave={onMouseLeave}>
        <div className={classes.message}>{message}</div>
      </div>
    </Fade>
  );
};

const getMessageForReason = (
  reason: VideoCallDisabledReasonsType,
): ReactNode => {
  if (reason === VideoCallDisabledReasonsType.MINIMAL_ANDROID_VERSION) {
    return <FormattedMessage id="videoCall.error.androidVersion" />;
  } else if (
    reason === VideoCallDisabledReasonsType.MINIMAL_ARDOIZ_CORE_VERSION
  ) {
    return <FormattedMessage id="videoCall.error.ardoizCoreVersion" />;
  }
};

type VideoCallCategoryDisabledOverlayProps = {
  disabledReason?: VideoCallDisabledReasonsType;
  showOverlay: boolean;
  onMouseLeave: MouseEventHandler;
};

const VideoCallCategoryDisabledOverlay = ({ disabledReason, showOverlay, onMouseLeave } : VideoCallCategoryDisabledOverlayProps) : JSX.Element | null => {
  if (disabledReason === undefined || !showOverlay) {
    return null;
  }

  const message = getMessageForReason(disabledReason);

  return (
    <VideoCallCategoryDisabledOverlayPure
      message={message}
      onMouseLeave={onMouseLeave}
    />
  );
};

export default VideoCallCategoryDisabledOverlay;
